/**
 * Saved Searches API client.
 */
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const CLIENT_ID_KEY = 'apisai.client_id';
function getClientId() {
  try {
    let id = localStorage.getItem(CLIENT_ID_KEY);
    if (!id) {
      id = (typeof crypto !== 'undefined' && crypto.randomUUID)
        ? crypto.randomUUID()
        : 'cid-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 12);
      localStorage.setItem(CLIENT_ID_KEY, id);
    }
    return id;
  } catch {
    return 'anon';
  }
}

const headers = () => ({ 'X-Client-Id': getClientId() });

export async function createSavedSearch(criteria) {
  const res = await axios.post(`${API}/saved-searches`, criteria, { headers: headers(), timeout: 12000 });
  return res.data;
}

export async function listSavedSearches() {
  try {
    const res = await axios.get(`${API}/saved-searches`, { headers: headers(), timeout: 8000 });
    return res.data?.items || [];
  } catch {
    return [];
  }
}

export async function getSavedSearchMatches(searchId, limit = 20) {
  const res = await axios.get(`${API}/saved-searches/${searchId}/matches`, {
    headers: headers(),
    params: { limit },
    timeout: 12000,
  });
  return res.data;
}

export async function deleteSavedSearch(searchId) {
  await axios.delete(`${API}/saved-searches/${searchId}`, { headers: headers(), timeout: 8000 });
  return true;
}

export async function updateSavedSearch(searchId, patch) {
  const res = await axios.patch(`${API}/saved-searches/${searchId}`, patch, { headers: headers(), timeout: 8000 });
  return res.data;
}
